export default __webpack_public_path__ + "static/media/Obituary.d99bbc18.pdf";